import axios from "axios";
import { getAnonId } from "@/lib/anonId";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Send a stable anonymous identifier on every request. Backend keys
// rate-limits off ``user_id`` when the session is signed in, and falls
// back to this header for guests — so guests get a coherent paywall
// counter even before they sign in.
api.interceptors.request.use((config) => {
  try {
    config.headers = config.headers || {};
    if (!config.headers["X-Anon-Id"]) {
      config.headers["X-Anon-Id"] = getAnonId();
    }
  } catch {
    /* never block a request because the header builder threw */
  }
  return config;
});

export const formatTime = (ms) => {
  if (!ms || isNaN(ms)) return "0:00";
  const s = Math.floor(ms / 1000);
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, "0")}`;
};

// Helpers — resolve relative ``/api/...`` paths returned by our own
// upload endpoints against the backend host. Some browsers (and same-
// origin policies on the production domain) fail silently when an
// <img> sees a path like ``/api/uploads/file/cover/x.jpg`` — making
// it absolute against ``REACT_APP_BACKEND_URL`` removes that risk and
// also makes the URLs portable for tests / preview-vs-prod debugging.
const _resolveRelative = (url) => {
  if (!url) return "";
  if (typeof url !== "string") return url;
  if (url.startsWith("/api/") || url.startsWith("/uploads/")) {
    return `${BACKEND_URL}${url}`;
  }
  return url;
};

// iTunes returns artworkUrl100; upscale to 600
export const bigArt = (url) => {
  if (!url) return "";
  const resolved = _resolveRelative(url);
  return resolved
    .replace("100x100bb", "600x600bb")
    .replace("60x60bb", "600x600bb")
    .replace("30x30bb", "600x600bb");
};

export const mediumArt = (url) => {
  if (!url) return "";
  return _resolveRelative(url).replace("100x100bb", "300x300bb");
};
